module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [(item.button) ? _c('a', {
      attrs: {
        "data-fancybox": "",
        "data-src": ("#" + (item.button.popupFormID)),
        "href": "javascript:;",
        "data-key": item.button.key
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]) : _c('a', {
      attrs: {
        "href": item.href
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1880d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/main-slider-v2.vue
// module id = 283
// module chunks = 38